// src/components/Toast/ToastHost.jsx
import React from "react";
import { useToast } from "../../contexts/ToastContext";

export default function ToastHost() {
  const { toasts, removeToast } = useToast();

  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite" aria-relevant="additions removals">
      {toasts.map((t) => {
        const clickable = typeof t.onClick === "function";
        return (
          <div
            key={t.id}
            className={`toast toast-${t.type || "info"}`}
            role="status"
            onClick={clickable ? () => t.onClick() : undefined}
            style={{ cursor: clickable ? "pointer" : "default" }}
          >
            <div className="toast-row">
              <div className="toast-msg">{t.message}</div>
              <button
                className="toast-close"
                type="button"
                aria-label="Fechar notificação"
                onClick={(e) => {
                  e.stopPropagation();
                  removeToast(t.id);
                }}
              >
                ×
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
